import { createAsyncThunk } from "@reduxjs/toolkit";
import { getRequest } from "shared/utils/fetch-api";

export const fetchProjects = createAsyncThunk(
    'contract/fetchProjects',
    async (_, { rejectWithValue }) => {
        try {
            const response = await getRequest({
                "Limit": 100000000000,
                "Offset": 0,
                "SortableColumns": []
            }, 'dms-hr', 'getInsuranceContractProjects', 'POST');
            const data = await response.json();
            if (data.Errors.length === 0) {
                return { Projects: data.Projects, ProjectCount: data.ProjectCount };
            } else {
                return rejectWithValue(data.Errors);
            }
        } catch (error: any) {
            return rejectWithValue(error.message);
        }
    }
);

export const fetchProjectsDownload = createAsyncThunk(
    'contract/fetchProjectsDownload',
    async (_, { rejectWithValue }) => {
        try {
            const response = await getRequest({}, 'dms-hr', 'downloadProjects', 'POST');
            const data = await response.json();
            if (data.Errors.length === 0) {
                return { FileData: data.File.DataBase64, FileName: data.File.Name };
            } else {
                return rejectWithValue(data.Errors);
            }
        } catch (error: any) {
            return rejectWithValue(error.message);
        }
    }
);